import { combineReducers } from 'redux';

export const suppliersInitialState = {
  suppliers: [],
  isLoading: false,
  error: null,
};

function suppliersReducer(state = suppliersInitialState, action = {}) {
  switch (action.type) {
    case 'GET_FOOD_PURCHASING_SUPPLIERS_REQUEST': {
      return {
        ...state,
        isLoading: true,
      };
    }
    case 'GET_FOOD_PURCHASING_SUPPLIERS_FAILURE': {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }
    case 'GET_FOOD_PURCHASING_SUPPLIER_ITEMS_SUCCESS': {
      const { id, name, phone, minimum_spend: minimumSpend } = action.payload;
      let suppliers = state.suppliers;
      if (!suppliers.find((_) => _.id === id)) {
        suppliers = suppliers.slice();
        suppliers.push({ id, name, phone, minimumSpend });
      }
      return {
        ...state,
        suppliers,
        error: null,
        isLoading: false,
      };
    }
    case 'GET_FOOD_PURCHASING_SUPPLIERS_SUCCESS': {
      return {
        ...state,
        suppliers: action.payload.suppliers.map((supplier) => ({
          id: String(supplier.id),
          name: supplier.name,
          phone: supplier.phone,
          minimumSpend: supplier.minimum_spend,
        })),
        error: null,
        isLoading: false,
      };
    }
    default:
      return state;
  }
}

export const supplierItemsInitialState = {
  supplierItems: [],
  isLoading: false,
  error: null,
};

function supplierItemsReducer(state = supplierItemsInitialState, action = {}) {
  switch (action.type) {
    case 'GET_FOOD_PURCHASING_SUPPLIER_ITEMS_REQUEST': {
      return {
        ...state,
        isLoading: true,
      };
    }
    case 'GET_FOOD_PURCHASING_SUPPLIER_ITEMS_FAILURE': {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }
    case 'GET_FOOD_PURCHASING_SUPPLIER_ITEMS_SUCCESS': {
      return {
        ...state,
        supplierItems: action.payload.supplier_items.map((item) => ({
          id: String(item.id),
          name: item.name,
          description: item.description,
          amount: item.display_amount,
          amountUnit: item.unit_display,
          price: item.unit_price,
          unitsPerPack: item.units_per_pack,
        })),
        error: null,
        isLoading: false,
      };
    }
    default:
      return state;
  }
}

export default combineReducers({
  suppliers: suppliersReducer,
  supplierItems: supplierItemsReducer,
});
